const module = {
  firestorePath: 'toplists',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'toplist',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      business: {},
      category: {},
      showOnMainPage: false,
      author: {},
      owner: {},

      dateRegister: null,
      dateExpired: null,
      dateRenewal: null,
      priceRegister: 0,
      priceRenewal: 0,
      billingCycle: 12,

      status: '',
      isDeleted: false
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {
    arrayData: state => {
      let data = []

      for (const key in state.data) {
        if (state.data.hasOwnProperty(key)) {
          data.push(state.data[key]);
        }
      }

      return data
    }
  },
  mutations: {},
  actions: {},
}

export default module
